import config from '../../config';

export default {
  url: `${config.api.baseURL}/accounts/:accountId/profiles/:profileId/has-pin`,
  transformer(data) {
    return data;
  }
};



// WEBPACK FOOTER //
// ./src/api/hasPin/list.js